function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

export { _arrayWithHoles as default };
